import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";

const WhatsAppFloat = ({ onClick }) => {
  const [visible, setVisible] = useState(false);
  const { lang } = useLanguage();
  useEffect(() => {
    const hero = document.getElementById("inicio");
    if (!hero) { setVisible(true); return; }
    const observer = new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting));
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  if (!visible) return null;
  return (
  <button
    onClick={onClick}
    aria-label={content[lang].contact.kicker}
    data-testid="floating-contact-button"
    className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-narwhal-teal text-narwhal-dark shadow-lg shadow-narwhal-teal/20 hover:scale-110 hover:bg-white transition-transform"
  >
    <MessageCircle className="w-6 h-6" />
  </button>
  );
};

export default WhatsAppFloat;
